var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.00011H19C20.1046 9.00011 21 9.89554 21 11.0001V17.0001C21 17.5524 20.5523 18.0001 20 18.0001V21.0001C20 21.5524 19.5523 22.0001 19 22.0001H5C4.44772 22.0001 4 21.5524 4 21.0001V18.0001C3.44772 18.0001 3 17.5524 3 17.0001V11.0001C3 9.89554 3.89543 9.00011 5 9.00011H11V6.72011C10.3849 6.365 10.0043 5.71033 10 5.00011C10.2548 3.96309 10.7556 3.00268 11.46 2.20011C11.5522 2.0716 11.7019 1.99679 11.86 2.00011H12.14C12.2981 1.99679 12.4478 2.0716 12.54 2.20011C13.2444 3.00268 13.7452 3.96309 14 5.00011C13.9957 5.71033 13.6151 6.365 13 6.72011V9.00011ZM6 17.8701V20.0001H18V17.8701C17.0817 17.6254 16.2805 17.0617 15.74 16.2801C14.8034 17.3706 13.4375 17.9981 12 17.9981C10.5625 17.9981 9.19658 17.3706 8.26 16.2801C7.71947 17.0617 6.91829 17.6254 6 17.8701Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.f169deeb11024e37f45b74158e0514da.svg";
export { ForwardRef as ReactComponent };